// General
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';


// Component
import Receipt from '../../components/Receipt';
import Loader from '../../components/Loader';

// Graphql
import getReceiptQuery from './getReceiptQuery.graphql';
import { withQuery } from '../../hoc/withGraphql';

import s from './ReceiptContainer.css';

const ReceiptContainer = ({ receiptData: { loading, getItinerary, refetch } }) => {

  if (loading) {
    return (
      <>
        <Loader type={"text"} show={loading} />
      </>
    );
  }

  return (
    <>
      <Receipt data={getItinerary} refetch={refetch} />
    </>
  );
}
ReceiptContainer.propTypes = {
  reservationId: PropTypes.number.isRequired,
  receiptData: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getItinerary: PropTypes.object.isRequired
  })
};

ReceiptContainer.defaultProps = {
  itineraryData: {
    loading: true,
  }
};

export default compose(
  withStyles(s),
  withQuery(getReceiptQuery,
    {
      name: 'receiptData',
      options: (props) => ({
        variables: {
          reservationId: props.reservationId,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(ReceiptContainer);